import { Query } from '@apollo/client/react/components';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import { withRouter } from 'react-router';

import LoadingArea from '~/components/LoadingArea';

import query from './query.graphql';
import styles from './styles.style';

class NewsDetail extends React.Component {
  render() {
    const { data, id, loading, classes, history } = this.props;
    const newsArticles = get(data, 'news.articles', []);
    let newsItem;
    let previousArticle;

    for (let index = 0; index < newsArticles.length; index++) {
      const article = newsArticles[index];
      if (article.id == id) {
        newsItem = article;
        previousArticle = newsArticles[index + 1];
      }
    }

    const backgroundImage = get(newsItem, 'image');

    return (
      <LoadingArea loading={loading} empty={!newsItem} className={classes.root}>
        {newsItem && (
          <div className={classes.newsDetail}>
            {backgroundImage && (
              <img
                className={classes.headerImage}
                alt="news-detail"
                oneEror="this.onerror=null;"
                src={`https://${backgroundImage}`}
              />
            )}
            <div className={classes.body}>
              <div className={classes.header}>
                <span className={classes.title}>{newsItem.title}</span>
                <p className={classes.timeago}>
                  {startCase(moment(get(newsItem, 'createdAt')).fromNow())}
                </p>
              </div>
              <ReactMarkdown>{newsItem.body}</ReactMarkdown>
            </div>
            {previousArticle && (
              <div className={classes.footer}>
                <span className={classes.dimTitle}>Previously</span>
                <span
                  onClick={() => history.push(`/news/${previousArticle.id}`)}
                  className={classes.link}>
                  {previousArticle.title}
                </span>
              </div>
            )}
          </div>
        )}
      </LoadingArea>
    );
  }
}

NewsDetail.propTypes = {
  data: PropTypes.shape({
    news: PropTypes.shape({
      articles: PropTypes.PropTypes.arrayOf(
        PropTypes.shape({
          createdAt: PropTypes.string,
          title: PropTypes.string,
          body: PropTypes.string,
          image: PropTypes.string,
        }),
      ),
    }),
  }),
  history: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  classes: PropTypes.object,
};

const WrappedNewsDetail = (props) => (
  <Query query={query}>
    {(graphQLProps) => <NewsDetail {...graphQLProps} {...props} />}
  </Query>
);

export default withRouter(withStyles(styles)(WrappedNewsDetail));
